/**
 * The little markdown a consent text uses: paragraphs and `**bold**` lead-ins, nothing else.
 *
 * Parsed here rather than through a markdown library because that is the whole grammar, and a
 * native `Text` tree renders it without any web-only dependency.
 */
export interface TextRun {
	text: string
	bold: boolean
}

export type Paragraph = TextRun[]

const BOLD = /\*\*(.+?)\*\*/g

export const parseConsentText = (text: string | undefined): Paragraph[] => {
	if (!text) {
		return []
	}

	return text
		.split(/\n\s*\n/)
		.map((paragraph) => paragraph.trim())
		.filter((paragraph) => paragraph.length > 0)
		.map(parseParagraph)
}

const parseParagraph = (paragraph: string): Paragraph => {
	const runs: Paragraph = []
	let cursor = 0

	for (const match of paragraph.matchAll(BOLD)) {
		const start = match.index ?? 0
		if (start > cursor) {
			runs.push({ text: paragraph.slice(cursor, start), bold: false })
		}
		runs.push({ text: match[1] ?? '', bold: true })
		cursor = start + match[0].length
	}

	if (cursor < paragraph.length) {
		runs.push({ text: paragraph.slice(cursor), bold: false })
	}

	return runs
}
